/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamStats
 */
export interface TeamStats {
    /**
     * 
     * @type {number}
     * @memberof TeamStats
     */
    wins?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamStats
     */
    losses?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamStats
     */
    matchesPlayed?: number;
    /**
     * Positive for win streak, negative for loss streak
     * @type {number}
     * @memberof TeamStats
     */
    currentStreak?: number;
    /**
     * Times a score this team submitted was overturned by a dispute
     * @type {number}
     * @memberof TeamStats
     */
    overturnedScores?: number;
    /**
     * Times a dispute this team filed was rejected
     * @type {number}
     * @memberof TeamStats
     */
    rejectedDisputes?: number;
}

/**
 * Check if a given object implements the TeamStats interface.
 */
export function instanceOfTeamStats(value: object): value is TeamStats {
    return true;
}

export function TeamStatsFromJSON(json: any): TeamStats {
    return TeamStatsFromJSONTyped(json, false);
}

export function TeamStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamStats {
    if (json == null) {
        return json;
    }
    return {
        
        'wins': json['wins'] == null ? undefined : json['wins'],
        'losses': json['losses'] == null ? undefined : json['losses'],
        'matchesPlayed': json['matchesPlayed'] == null ? undefined : json['matchesPlayed'],
        'currentStreak': json['currentStreak'] == null ? undefined : json['currentStreak'],
        'overturnedScores': json['overturnedScores'] == null ? undefined : json['overturnedScores'],
        'rejectedDisputes': json['rejectedDisputes'] == null ? undefined : json['rejectedDisputes'],
    };
}

export function TeamStatsToJSON(json: any): TeamStats {
    return TeamStatsToJSONTyped(json, false);
}

export function TeamStatsToJSONTyped(value?: TeamStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'wins': value['wins'],
        'losses': value['losses'],
        'matchesPlayed': value['matchesPlayed'],
        'currentStreak': value['currentStreak'],
        'overturnedScores': value['overturnedScores'],
        'rejectedDisputes': value['rejectedDisputes'],
    };
}

